var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.909 100.61V21.3896C110.909 12.6404 103.817 5.54541 95.0649 5.54541H15.8442C7.09184 5.54541 0 12.6404 0 21.3896V100.61C0 109.356 7.09184 116.454 15.8442 116.454H95.0649C103.817 116.454 110.909 109.363 110.909 100.61ZM22.974 25.3506H54.7828C57.4065 25.3506 59.536 27.4769 59.536 30.1039C59.536 32.7308 57.4065 34.8571 54.7828 34.8571H22.974C20.3502 34.8571 18.2208 32.7308 18.2208 30.1039C18.2208 27.4769 20.3502 25.3506 22.974 25.3506ZM22.974 45.948H54.6623C57.2861 45.948 59.4156 48.0743 59.4156 50.7013C59.4156 53.3282 57.2861 55.4545 54.6623 55.4545H22.974C20.3502 55.4545 18.2208 53.3282 18.2208 50.7013C18.2208 48.0743 20.3502 45.948 22.974 45.948ZM87.9351 96.6493H22.974C20.3502 96.6493 18.2208 94.5199 18.2208 91.8961C18.2208 89.2659 20.3502 87.1428 22.974 87.1428H87.9351C90.5589 87.1428 92.6883 89.2659 92.6883 91.8961C92.6883 94.5199 90.5589 96.6493 87.9351 96.6493ZM87.9351 76.0519H22.974C20.3502 76.0519 18.2208 73.9224 18.2208 71.2987C18.2208 68.6685 20.3502 66.5454 22.974 66.5454H87.9351C90.5589 66.5454 92.6883 68.6685 92.6883 71.2987C92.6883 73.9224 90.5589 76.0519 87.9351 76.0519ZM99.3017 37.1989L83.7776 52.7293C83.0519 53.4581 82.0981 53.8226 81.1411 53.8226C80.1873 53.8226 79.2303 53.4581 78.5046 52.7325L68.8872 43.1341C67.4327 41.6796 67.4264 39.3156 68.8872 37.8548C70.3449 36.3972 72.7057 36.3971 74.1602 37.8516L81.1348 44.8136L94.0224 31.9196C95.48 30.4619 97.8408 30.4619 99.3017 31.9196C100.759 33.3773 100.759 35.7349 99.3017 37.1989ZM122 32.3664V102.442C122 110.177 115.729 116.454 107.984 116.454H100.084C108.837 116.454 115.929 109.363 115.929 100.61V21.3896C115.929 21.1836 115.871 20.9903 115.865 20.7843C119.566 23.3035 122 27.5498 122 32.3664Z",
    fill: "url(#paint0_linear_341_2382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_2382",
    x1: -2.05474,
    y1: 120.301,
    x2: 143.147,
    y2: 70.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_2382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsCheckIcon);
export default __webpack_public_path__ + "static/media/documents-check-icon.a22871068856601ae899420b00ea9d1e.svg";
export { ForwardRef as ReactComponent };